import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import HandWristDermalPiercingImage from '../../Assets/Piercing Services/Hand wrist dermal.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function HandWristDermalPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Hand Wrist Dermal Piercing UAE | 450 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Hand Wrist Dermal Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Hand Wrist Dermal Piercing 450 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={HandWristDermalPiercingImage} alt="Hand Wrist Dermal Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Hand Wrist Dermal Piercing</h3>

          <p>
            Elevate your body art with our professional hand wrist dermal piercing services in the UAE, available at a premium price of 450 AED. Hand wrist dermal piercing is a trendy and modern surface piercing that places a small, elegant piece of jewelry directly into the skin of the wrist or hand area, creating the illusion of a delicate ornament resting on your skin. This unique and stylish piercing is perfect for individuals who want to stand out with something different from traditional jewelry, offering a bold yet sophisticated look that enhances your overall appearance. Whether you choose a subtle crystal or a decorative design, this piercing adds a refined and eye-catching detail to your style.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each hand wrist dermal piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Dermal piercings require specialized expertise, especially in areas like the wrist that are exposed to frequent movement, and our experienced specialists are trained to ensure proper placement and stability while minimizing discomfort.
          </p>

          <p>
            Hand wrist dermal piercing is ideal for individuals who love unique and creative body art. Its placement allows it to act as a subtle yet striking accessory, making it a great alternative to traditional bracelets or rings. This piercing can be worn alone for a minimal look or combined with other dermal piercings for a more personalized and bold design. Our specialists take the time to understand your preferences and guide you in selecting the best placement and jewelry options to suit your lifestyle and aesthetic goals.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic dermal jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that dermal piercings can feel intimidating, especially for first-time clients, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for hand wrist dermal piercings due to constant movement and exposure. We provide detailed instructions to help you maintain proper care during the healing period, including cleaning routines, protective measures, and precautions to avoid irritation or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our hand wrist dermal piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive excellent value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted hand wrist dermal piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a unique and stylish look effortlessly. Book your hand wrist dermal piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Hand Wrist Dermal Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default HandWristDermalPiercing;